<template>
    <v-card
    flat
    color="transparent"
    v-if="questions.length > 0 && (!main || Role('lead'))"
  >
    <v-list-item>
      <!--v-list-item-avatar color="grey"></v-list-item-avatar-->
      <v-list-item-content v-if="main && Role('lead')">
        <v-list-item-title class="headline">Labels</v-list-item-title>
        <v-list-item-subtitle>Onderstaande labels zijn voor u ingesteld op basis waarvan de vragenlijst is opgebouwd. Rechts vindt u mogelijke vragen die u kunt stellen aan de leveranciers.</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-content v-if="!main && Role('lead')">
        <v-list-item-title class="headline">Labels voor {{selected._supplier.name}}</v-list-item-title>
        <v-list-item-subtitle>Hieronder vindt u reeds ingestelde antwoorden voor {{selected._supplier.name}}. U kunt hierboven de vragenlijst completeren om een volledig beeld te krijgen van deze leverancier.</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    
    <v-card-text>
     <v-list class="transparent">
          <v-list-item  v-for="(question, ii) in questions"
                :key="ii">
                  <v-list-item-content>
                                              <v-list-item-title>{{getText(question)}}</v-list-item-title>
                                              </v-list-item-content>
      </v-list-item>
  </v-list>
    </v-card-text>
  </v-card>
    
 
  
                    
</template>

<script>

import {
  mapActions,
  mapState,
  mapMutations, mapGetters
} from 'vuex'

export default {

    props: ['item', "max", "number","main","disabled","template"],
    data: () => ({
     
    }),
    computed: {
       ...mapGetters('auth', ["Role"]),
         ...mapState('auth', ['authenticated',"settings"]),
         ...mapState('match', ['selected','templates']),
       questions () {
        var self = this
        return this.templates.filter(
            q => self.tags.includes(q.tag)
            || self.tags.includes(q.notag))
      },
      tags () {
        if (this.selected.tags) return this.selected.tags.map(t => t.tag) //.filter(q=> q.type=='branche' || q.type=='category')
        return this.settings.tags.map(t => t.tag) //.filter(q=> q.type=='branche' || q.type=='category')
      },
      answers () {
          return this.selected.answers
      }
    },
    mounted() {
   
    },
    methods : {
       getText(q){
          if (this.tags.includes(q.tag)) return q.answer || q.tag
          if (this.tags.includes(q.notag)) return q.no_answer || q.notag
       }
    }
}
</script>
